export const SET_COUPON_CODE = 'SET_COUPON_CODE';
export const SET_COUPON_TYPE = 'SET_COUPON_TYPE';
export const SET_COUPON_VALUE = 'SET_COUPON_VALUE';
export const SET_COUPON_APPLIED = 'SET_COUPON_APPLIED';
export const SET_OLD_FEE = 'SET_OLD_FEE';
export const SET_OLD_CHARGES = 'SET_OLD_CHARGES';
export const SET_SAVINGS = 'SET_SAVINGS';